import { useMemo } from "react";
import { Route, Routes, useSearchParams } from "react-router";
import { withAuthenticationRequired } from "react-oidc-context";
import { ChangePin } from "../ChangePin/ChangePin";
import { EventList } from "../Events/EventList/EventList";
import { getAuthenticationContextReference } from "~/helpers/getAuthenticationContextReference";
import { Home } from "../Home/Home";
import { Login } from "~/components/Login/Login";
import { MainLayout } from "../Layout/MainLayout";
import { NotFound } from "../NotFound/NotFound";
import { Pdf } from "../Pdf/Pdf";
import { ProtectedRoute } from "~/components/Base/ProtectedRoute/ProtectedRoute";
import { PublicLayout } from "../Layout/PublicLayout";
import { RedirectPage } from "../RedirectPage/RedirectPage";
import { Settings } from "../Settings/Settings";
import { SigninCallback } from "~/components/SigninCallback/SigninCallback";
import { StudyInfo } from "../StudyInfo/StudyInfo";
import { UnscheduledEventList } from "../Events/UnscheduledEventList/UnscheduledEventList";
import { ValidatePageIdForm } from "../ValidatePageIdForm/ValidatePageIdForm";
import { Welcome } from "../Welcome/Welcome";

export const ApplicationRoutes = () => {
  const [searchParams] = useSearchParams();
  const loginHint = searchParams.get("login_hint");
  const acrValues = getAuthenticationContextReference(
    searchParams.get("authm"),
    searchParams.get("locale")
  );

  const RequireAuth = useMemo(() => {
    const signinRedirectArgs = {
      ...(loginHint && { login_hint: loginHint }),
      ...(acrValues && { acr_values: acrValues }),
    };

    return withAuthenticationRequired(ProtectedRoute, {
      signinRedirectArgs,
      OnRedirecting: () => <RedirectPage />,
    });
  }, [loginHint, acrValues]);

  return (
    <Routes>
      <Route path="/signin-oidc" element={<SigninCallback />} />
      <Route path="/login" element={<Login />} />
      <Route path="/pdf/:formId" element={<Pdf />} />
      <Route element={<PublicLayout />}>
        <Route element={<RequireAuth />}>
          <Route path="/change-pin" element={<ChangePin />} />
          <Route path="/welcome" element={<Welcome />} />
        </Route>
      </Route>
      <Route element={<RequireAuth />}>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Home />} />
          <Route path="study" element={<StudyInfo />} />
          <Route path="settings" element={<Settings />} />
          <Route path="events">
            <Route index element={<EventList />} />
            <Route
              path=":eventId/form/:page"
              element={<ValidatePageIdForm />}
            />
          </Route>
          <Route path="unscheduled-events">
            <Route index element={<UnscheduledEventList />} />
            <Route
              path=":eventId/form/:page"
              element={<ValidatePageIdForm />}
            />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Route>
      </Route>
    </Routes>
  );
};
